import APP_ACTIONS from '../constants/app-actions';
import OrdersAPI from '../apis/order';
import LineItemAPI from '../apis/line-item';
import localStorageAPI from '../services/local-storage-api';

import lineItem from './line-item';
import cartState from './cart-state';
import FingerprintService from '../services/fingerprint-service';

const order = {
    clearOrder: () => (dispatch, getState) => {
        dispatch(cartState.setHasExtraTimeCheckout(false));
        dispatch({ type: APP_ACTIONS.DESTROY_ORDER });
        localStorageAPI.save(getState());
    },

    /* This is called whenever:
    1. Order is updated.
    2. Moved to a different state in checkout flow. */
    updateOrderInState: (receivedOrder) => (dispatch, getState) => {
        /*
        receivedOrder can be empty when, for example, a new user is registered
        or when a user with no current order logs in.
      */
        if (receivedOrder.data.id) {
            dispatch({ type: APP_ACTIONS.UPDATE_ORDER, payload: receivedOrder });
            localStorageAPI.save(getState());
        }
    },

    refreshOrder: (locale) => (dispatch, getState) => {
        const { order: { token }, zones: { currentZone } } = getState();

        return OrdersAPI.get({ token, locale, currentZone }).then(
            (response) => {
                dispatch({ type: APP_ACTIONS.UPDATE_ORDER, payload: response.body });
                localStorageAPI.save(getState());
                return response;
            },
        );
    },

    addProductToCart: (variantId, quantity = 1, zoneId, locale, userToken = null, extraParam = null) => (dispatch, getState) => {
        const { order: cartOrder, municipalities: { currentMunicipality } } = getState();
        if (cartOrder.id === undefined) {
            return FingerprintService.info.then(
                (fpInfo) => OrdersAPI.create(locale, userToken, fpInfo, currentMunicipality).then(
                    (response) => {
                        const cart = response.body.data;

                        dispatch({
                            type: APP_ACTIONS.CREATE_ORDER,
                            payload: {
                                ...cartOrder, store: getState().stores.currentStore, ...cart.attributes, id: cart.id,
                            },
                        });
                        localStorageAPI.save(getState());

                        return dispatch(
                            lineItem.addLineItem({
                                variantId,
                                quantity,
                                zoneId,
                                orderToken: cart.attributes.token,
                                locale,
                                extraParam,
                            }),
                        );
                    },
                ),
            );
        }
        return dispatch(
            lineItem.addLineItem({
                variantId,
                quantity,
                zoneId,
                orderToken: cartOrder.token,
                locale,
                extraParam,
            }),
        );
    },

    emptyCart: (cartOrder, locale, initialToken = null) => (dispatch, getState) => {
        const token = initialToken === null ? cartOrder.token : initialToken;
        return OrdersAPI.destroy({ token, locale }).then((response) => response).finally(() => {
            // no matter what response we receive, if destroy is called we want to clear the local state
            dispatch({ type: APP_ACTIONS.DESTROY_ORDER });
            dispatch(cartState.setTimeSecondsLeft(0));
            dispatch(cartState.setHasExtraTimeCheckout(false));
            localStorageAPI.save(getState());
        });
    },

    emptyCurrentCart: () => (dispatch, getState) => {
        const { order: { token }, locale: { currentLocale: locale } } = getState();
        return OrdersAPI.destroy({ token, locale }).then((response) => response).finally(() => {
            // no matter what response we receive, if destroy is called we want to clear the local state
            dispatch({ type: APP_ACTIONS.DESTROY_ORDER });
            dispatch(cartState.setTimeSecondsLeft(0));
            dispatch(cartState.setHasExtraTimeCheckout(false));
            localStorageAPI.save(getState());
        });
    },

    addingProductToCart: () => (dispatch, getState) => {
        dispatch({ type: APP_ACTIONS.ADDING_PRODUCT_TO_CART });
        localStorageAPI.save(getState());
    },

    addingProductToCartFix: (adding) => (dispatch, getState) => {
        dispatch({ type: APP_ACTIONS.ADDING_PRODUCT_TO_CART_TO_FIX, payload: adding });
        localStorageAPI.save(getState());
    },

    removingProductToCart: (nextState) => (dispatch, getState) => {
        dispatch({ type: APP_ACTIONS.REMOVING_PRODUCT_TO_CART, payload: nextState });
        localStorageAPI.save(getState());
    },

    removeProductFromCart: (lineItemId, locale) => (dispatch, getState) => {
        const { token } = getState().order;

        return LineItemAPI.destroy({ token, lineItemId, locale }).then((response) => {
            dispatch({ type: APP_ACTIONS.REMOVE_LINE_ITEM, payload: lineItemId });

            localStorageAPI.save(getState());
            return response;
        });
    },

    removeDataExtraFromCart: (dataExtraId, locale) => (dispatch, getState) => {
        const { token } = getState().order;

        return LineItemAPI.destroyDataExtra({ token, dataExtraId, locale }).then((response) => {
            dispatch({ type: APP_ACTIONS.REMOVE_DATA_EXTRA_ITEM, payload: response.body });

            localStorageAPI.save(getState());
            return response;
        });
    },

    changeProductQuantityFromCart: (quantity, lineItemId, zoneId, locale) => (dispatch, getState) => {
        const { token } = getState().order;
        return LineItemAPI.update({
            quantity,
            token,
            lineItemId,
            zoneId,
            locale,
        }).then((response) => {
            dispatch({ type: APP_ACTIONS.UPDATE_LINE_ITEM, payload: response.body });

            localStorageAPI.save(getState());
            return response;
        });
    },

    getById: (id) => (dispatch, getState) => {
        const { token } = getState().order;
        return OrdersAPI.getById({ id, token });
    },
    setIsFinalStepHappening: (isFinalStepHappening) => ({
        type: APP_ACTIONS.SET_IS_FINAL_STEP_HAPPENING,
        payload: isFinalStepHappening,
    }),
    syncOrderFromStorage: (newOrder) => ({
        type: APP_ACTIONS.SYNC_ORDER_FROM_STORAGE,
        payload: newOrder,
    }),
};

export default order;



/** WEBPACK FOOTER **
 ** ./src/actions/order.js
 **/